import { useNotesStore } from '@/stores/notes'
import { createPrefetchGuard } from '@/utils/routerGuards'

export default [
    {
        path: '/notes',
        name: 'notes',
        component: () => import('@/views/Notes/Index.vue'),
        meta: {
            title: 'notes.pageTitle',
            menuRendered: true,
            menuTitle: 'notes.menuTitle',
            requiresAuth: true,
            permission: ['production_sites_notes_admin_read', 'production_sites_note_leader_read'],
            icon: 'mdi-note-text'
        },
        redirect: { name: 'notesProductionSiteNotes' },
        children: [
            {
                path: '/notes/production-site-notes',
                name: 'notesProductionSiteNotes',
                component: () => import('@/views/Notes/ProductionSiteNotes/Index.vue'),
                meta: {
                    title: 'notes.pageTitle',
                    requiresAuth: true,
                    permission: ['production_sites_notes_admin', 'production_sites_note_leader']
                }
            },
            {
                path: '/notes/production-site-notes/create',
                name: 'notesProductionSiteNoteCreate',
                component: () => import('@/views/Notes/ProductionSiteNotes/ProductionSiteNote.vue'),
                meta: {
                    title: 'notes.createNotePageTitle',
                    requiresAuth: true,
                    permission: ['production_sites_notes_admin_create', 'production_sites_note_leader_create']
                }
            },
            {
                path: '/notes/production-site-notes/edit/:id',
                name: 'notesProductionSiteNoteEdit',
                component: () => import('@/views/Notes/ProductionSiteNotes/ProductionSiteNote.vue'),
                beforeEnter: createPrefetchGuard({
                    getId: (to) => to.params?.id,
                    fetch: async (id) => {
                        const notesStore = useNotesStore()
                        await Promise.all([notesStore.fetchProductionSiteNote(id), notesStore.fetchProductionSiteFormSites()])
                    },
                    loader: 'circular',
                    onMissingId: () => ({ name: 'notesProductionSiteNotes' }),
                    onError: () => ({ name: 'notesProductionSiteNotes' })
                }),
                meta: {
                    title: 'notes.editNotePageTitle',
                    requiresAuth: true,
                    permission: ['production_sites_notes_admin_update', 'production_sites_note_leader_update']
                }
            }
        ]
    }
]
